/** @format */

export const productConditions = [
  { text: 'Nuovo', value: 'new' },
  { text: 'Usato', value: 'second_hand' },
  { text: 'Rigenerato', value: 'refurbished' },
];

export const productConditionsMapped = {
  new: 'Nuovo',
  second_hand: 'Usato',
  refurbished: 'Rigenerato',
};
